import { BizTypeEnum } from './biz-type-enum'
import { UserDomainEnum } from './user-domain-enum'
import { PaperQuestion } from './paper-question'

export interface PaperAnswerLogInterface {
  bizId?: number
  bizType?: BizTypeEnum
  /**
   * 关联的活动任务 ID
   */
  activityTaskId?: number
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否发布
   */
  isPublished?: boolean
  /**
   * 分配试卷id
   */
  paperId: number
  /**
   * 前一次答案记录id
   */
  preId: number
  /**
   * 所属提交人
   */
  submitterId?: number
  /**
   * 所属提交人
   */
  submitterDomain: UserDomainEnum
  question?: PaperQuestion
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class PaperAnswerLog implements PaperAnswerLogInterface {
  bizId?: number
  bizType?: BizTypeEnum
  /**
   * 关联的活动任务 ID
   */
  activityTaskId?: number
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否发布
   */
  isPublished?: boolean
  /**
   * 分配试卷id
   */
  paperId: number
  /**
   * 前一次答案记录id
   */
  preId: number
  /**
   * 所属提交人
   */
  submitterId?: number
  /**
   * 所属提交人
   */
  submitterDomain: UserDomainEnum
  question?: PaperQuestion
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: PaperAnswerLogInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      bizId: _bizId,
      bizType: _bizType,
      activityTaskId: _activityTaskId,
      questionId: _questionId,
      value: _value,
      isPublished: _isPublished,
      paperId: _paperId,
      preId: _preId,
      submitterId: _submitterId,
      submitterDomain: _submitterDomain,
      question: _question,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.bizId = _bizId
    this.bizType = _bizType
    this.activityTaskId = _activityTaskId
    this.questionId = _questionId
    this.value = _value
    this.isPublished = _isPublished
    this.paperId = _paperId
    this.preId = _preId
    this.submitterId = _submitterId
    this.submitterDomain = _submitterDomain
    this.question = _question ? new PaperQuestion(_question) : _question
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
